import { useMemo } from 'react';

export interface TrackingParams {
  trackingId: string | null;
}

export function useTrackingParams(): TrackingParams {
  return useMemo(() => {
    if (typeof window === 'undefined') {
      return { trackingId: null };
    }
    const params = new URLSearchParams(window.location.search);
    const raw = params.get('t')?.trim();
    return { trackingId: raw && raw.length > 0 ? raw : null };
  }, []);
}
